/* global tw */
import React from 'react'
import MDXRenderer from 'gatsby-mdx/mdx-renderer'
import { MDXProvider } from '@mdx-js/react'
import Highlight, { defaultProps } from 'prism-react-renderer'
import theme from 'prism-react-renderer/themes/nightOwl'

export const Code = ({ children, className }) => {
  const language = className ? className.replace(/language-/, '') : null
  return (
    <Highlight
      {...defaultProps}
      code={children}
      language={language}
      theme={theme}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={className} style={{ ...style, padding: '20px' }}>
          {tokens
            .filter(line => line.some(token => !token.empty))
            .map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
        </pre>
      )}
    </Highlight>
  )
}

const components = {
  code: Code,
}

export default ({ content }) => (
  <div css={tw`mb-4`}>
    <MDXProvider components={components}>
      <MDXRenderer>{content}</MDXRenderer>
    </MDXProvider>
  </div>
)
